module.exports = __webpack_public_path__ + "img/newyear2024-bg@2x.90f7f8a8.png";